import { ClassificationApp } from './ClassificationApp';
import { registerReactWebComponent } from '@/core/utils/webComponent';

export const registerClassificationComponent = () => {
  registerReactWebComponent('content-classification-wall', ClassificationApp, () => {
    return {};
  });
};
